import {ZohoServise} from './core/services/answer/zoho.service';
import {Component} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {Gtag} from "angular-gtag";
declare let fbq:Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private zohoService: ZohoServise,
              public router: Router,
              private gtag: Gtag) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event.urlAfterRedirects;
        if (url && url.indexOf('/compare') !== -1) {
          url = '/compare'
        }
        gtag.pageview({
          page_path: url,
        });
        fbq('track', 'PageView');
      }
    })
  }

}
